/* eslint-disable camelcase */
import PropTypes from 'prop-types';
import {
  propTypesAltLanguage,
  propTypesIllustration,
  propTypesTextHtml,
} from '../../shared/constants/Proptypes';

export const propTypesEventTag = {
  last_publication_date: PropTypes.string,
  first_publication_date: PropTypes.string,
  lang: PropTypes.string,
  url: PropTypes.string,
  type: PropTypes.string,
  alternate_languages: PropTypes.arrayOf(PropTypes.shape(propTypesAltLanguage)),
  data: PropTypes.shape({
    color: PropTypes.string,
    illustration: PropTypes.shape(propTypesIllustration),
    meta_description: PropTypes.string,
    meta_title: PropTypes.string,
    page_title: PropTypes.string,
    subtitle: PropTypes.shape(propTypesTextHtml),
    title: PropTypes.shape(propTypesTextHtml),
  }),
};
